export function withSentryEventIdDescription(
  description: string | undefined,
  sentryEventId: string | undefined,
): string | undefined {
  if (!sentryEventId) return description;

  const eventIdDescription = `Fehler-ID: ${sentryEventId}`;
  return description
    ? `${description}\n${eventIdDescription}`
    : eventIdDescription;
}
